<template>
  <div
    v-if="!loaded"
    v-loading="true"
  />

  <component
    :is="component"
    v-else
    v-model="data"
    v-bind="props"
  />
</template>

<script>
import Widget from '@/plugins/dashboard/classes/BaseWidget'

export default {
  props: {
    widget: {
      type: Object,
      required: true,
      validator: function (value) {
        return value instanceof Widget
      }
    }
  },
  data () {
    return {
      loaded: false,
      data: undefined,
      props: undefined
    }
  },
  computed: {
    component () {
      return this.widget.constructor.widget
    }
  },
  created () {
    this.loadDataAndProps()
  },
  methods: {
    loadDataAndProps () {
      this.loaded = false
      Promise
        .all([
          Promise.resolve(this.widget.data),
          Promise.resolve(this.widget.props)
        ])
        .then(result => { [this.data, this.props] = result })
        .finally(() => { this.loaded = true })
    }
  }
}
</script>
